// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.total-time-elapsed-container  {\n    display: inline-flex;\n    align-items: center;\n    padding: 0 5px 0 0;\n    margin-left: 5px;\n  }\n  \n  .total-time-elapsed {\n    color: var(--primary-300);\n    font-weight: 500;\n  }", ""]);
// Exports
module.exports = exports;
